/** @jsx jsx */
import { jsx, Box, Container, Button } from "theme-ui";
import { rgba } from "polished";
import SectionHeading from "components/section-heading";
import ReactPlayer from "react-player";

const Banner = () => {
  return (
    <Box as="section" id="home" sx={styles.section}>
      {/* <img src={blueprint} style={{position: "absolute", width:"100%", height: "100%", top: "0", left: "0", opacity: "10%"}}/> */}
      <Container>
        <Box sx={styles.contentWrapper}>
          <SectionHeading
            sx={styles.heading}
            title="Reimagine garbage with iCleen"
            description="Discussions around smart cities tend to focus on more convenient living or transportation.
            It’s time we use the IoT to create a cleaner future."
          />
          <Box sx={styles.illustration}>
            <Box sx={styles.buttonWrapper}>
              <Button
                onClick={() => {
                  window.open("https://admin-eie-jedis.web.app", "_blank");
                }}
              >
                Try it out!
              </Button>
            </Box>
            {/* <Image src={illustration} alt="illustration"/> */}
          </Box>
          <Box sx={styles.video}>
            <ReactPlayer
              url="https://www.youtube.com/watch?v=Y02TwSxhdBM"
              style={{ maxWidth: "90vw" }}
              config={{
                youtube: {
                  playerVars: { fs: 1, modestbranding: 1, controls: 1 },
                },
                facebook: {
                  appId: "12345",
                },
              }}
            />
          </Box>
        </Box>
      </Container>
    </Box>
  );
};

export default Banner;

const styles = {
  section: {
    position: "relative",
    pt: [105, null, null, 140, 15, null, 170],
    pb: [8, null, null, 0],
    zIndex: 0,
    ":before": {
      backgroundColor: rgba("#FFF5ED", 0.5),
      content: ["none", null, null, `''`],
      position: "absolute",
      left: 0,
      right: 0,
      bottom: 0,
      height: 72,
      zIndex: -1,
    },
  },
  contentWrapper: {
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    justifyContent: "flex-end",
  },
  heading: {
    mb: [30],
    maxWidth: [null, null, null, 500, 560, 730],
    h2: {
      fontSize: [8, null, null, 8, 9, 10, 11],
      lineHeight: [1.57],
    },
    p: {
      fontSize: [1, null, null, 3],
      lineHeight: [1.87, null, null, 2.33],
    },
  },
  illustration: {
    display: ["block", null, null, "flex"],
    position: "relative",
    img: {
      display: ["none", null, null, "block"],
      maxWidth: ["90%"],
      m: ["0 auto"],
    },
  },
  video: {
    maxWidth: ["80%", "700px"],
    paddingTop: "10%",
    paddingBottom: "10%",
  },
  buttonWrapper: {
    textAlign: ["center"],
    position: ["static", null, null, "absolute"],
    left: "50%",
    top: 0,
    transform: ["unset", null, null, "translateX(-50%)"],
  },
};
